{
	"errorPage.404.button": "Powrót do strony głównej",
	"errorPage.404.code": "Błąd 404",
	"errorPage.404.description": "Przepraszamy, strona której szukasz nie istnieje lub została przeniesiona.",
	"errorPage.404.title": "Nie znaleziono strony…",
	"errorPage.network.description": "Nie udało się załadować strony.\nSprawdź połączenie z Internetem i spróbuj ponownie.",
	"errorPage.network.title": "Wystąpił błąd…",
	"global.refreshButton": "Odśwież",
	"global.toast.error.message": "Wystąpił błąd, spróbuj ponownie.",
	"global.toast.error.title": "Błąd"
}
